import { createContext, type Dispatch, type SetStateAction } from 'react';
import type { TransferContextData } from '../workflowCompletion/workflowTypes';

export const initialTransfer: TransferContextData = {};

export type DepositTransferContextType = {
  transferData: TransferContextData;
  setTransferData: Dispatch<SetStateAction<TransferContextData>>;
  mode: 'create' | 'edit';
};

export const DepositTransferContext = createContext<DepositTransferContextType>(
  {
    transferData: initialTransfer,
    setTransferData: () => {},
    mode: 'create',
  },
);
